module.exports = __webpack_public_path__ + "static/img/fast_staff_logo.ba7a0fe4.png";